// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash/omit';
import cx from 'classnames';
import get from 'lodash/get';
// Components
import ContactsPlaceholder from '../PropertyDetailedInfo/ContactsPlaceholder/ContactsPlaceholder';
import DescriptionPlaceholder from '../PropertyDetailedInfo/DescriptionPlaceholder/DescriptionPlaceholder';
import PropertySummary from '../PropertyDetailedInfo/PropertySummary/PropertySummary';
// Helpers
import beautifyNumber from '../../helpers/beautifyNumber';
// Styles
import * as styles from './PropertyDetailsPlaceholder.scss';

class PropertyDetailsPlaceholder extends Component {
  shouldComponentUpdate(newProps) {
    return !!newProps.loaded;
  }

  getSummaryData = (data = {}) => {
    const rawData = omit(data, 'propertyId');
    const directLink = !Object.keys(rawData).length;

    if (directLink) {
      return {
        price: '',
        address: {},
        additionalInfo: {}
      };
    }

    return {
      ...rawData,
      price: beautifyNumber(rawData.price),
      address: {
        cityName: rawData.address && rawData.address.city_name,
        streetName: rawData.address && rawData.address.street_name,
        houseNumber: rawData.address && rawData.address.house_number
      },
      additionalInfo: {
        ...rawData.additionalInfo,
        area: get(rawData, 'additionalInfo.area.base') || get(rawData, 'additionalInfo.area')
      }
    };
  };

  render() {
    const { isMobile, data, translate, className, isRtl } = this.props;
    return (
      <div className={cx(styles.propertyPlaceholder, styles[className], { [styles.mobile]: isMobile })}>
        <div className={styles.galleryPlaceholder} />

        <div className={styles.mainInfo}>
          <div className={styles.propertyInfo}>
            <div className={styles.propertyType}>
              { data && data.propertyType }&nbsp;
              { !isMobile ? <br /> : null }
              { data && data.optionType && translate('propertyType', data.optionType) }
            </div>

            <PropertySummary
              translate={translate}
              data={this.getSummaryData(data)}
              className={styles.propertySummary}
              isRtl={isRtl}
            />
          </div>

          <ContactsPlaceholder isMobile={isMobile} />
        </div>

        { isMobile ? <hr /> : null }

        <DescriptionPlaceholder isMobile={isMobile} />
      </div>
    );
  }
}

PropertyDetailsPlaceholder.propTypes = {
  translate: PropTypes.func,
  className: PropTypes.string,
  data: PropTypes.object,
  isMobile: PropTypes.bool,
  isRtl: PropTypes.bool
};

export default PropertyDetailsPlaceholder;
